'use strict'

var fromCharCode = String.fromCharCode

module.exports = fromCharCode
